<template>
  <div class="incenters">
    <div>
      <div class="topstate" v-for="(item , index) of state" :key="index" :class="[{ 'ativte' : onchage == index}]" @click="clicktab(index)">
        {{ item.title }}
      </div>
    </div>
    <div v-if="tableflag" lass="TableWidth">
      <Commontable colnum=7 :tableData="tableDataDetail" :loadingTable="loadingTable" :headerData="headerData" height="100%"></Commontable>
    </div>
    <div lass="TableWidth" v-if="tableflags">
      <Commontable colnum=7 :tableData="tableDataUnique"  :loadingTable="loadingTable" :headerData="headerData1" height="100%"></Commontable>
    </div>
  </div>
</template>

<script>
import Commontable from '../../../../components/common-table.vue'
import Commonbtn from '../../../../components/common-btn.vue'
import {
  TransVouchDetail,
  TransVouchDetailUnique
} from '@/api/home'
export default {
  components: {
    Commontable,
    Commonbtn,
  },
  props: ['tvmid', 'tableDataUnique', 'tableDataDetail'],
  data: function () {
    return {
      loadingTable: false,
      headerData1: [{
        prop: 'id',
        label: '序号',
        columnwidth: 50
      },
      {
        prop: 'InvAddCode',
        label: '商品代码',
      },
      {
        prop: 'InvName',
        label: '商品名称',
      },
      {
        prop: 'Batch',
        label: '批号',
      },
      {
        prop: 'ValiDate',
        label: '有效期至',
      },
      {
        prop: 'Quantity',
        label: '数量',
      },
      {
        prop: 'TaxUnitPrice',
        label: '含税单价',
      },
      {
        prop: 'Sum',
        label: '价税合计',
      },
      {
        prop: 'InvUniqueCode',
        label: '唯一码',
      },
      
      ],
      headerData: [{
        prop: 'id',
        label: '序号',
        columnwidth: 50
      },
      {
        prop: 'OHospitalName',
        label: '仓库',
      },
      {
        prop: 'InvAddCode',
        label: '商品代码',
      },
      {
        prop: 'InvName',
        label: '存货名称',
      },
      {
        prop: 'Batch',
        label: '批号',
      },
      {
        prop: 'ValiDate',
        label: '有效期至',
      },
      {
        prop: 'Quantity',
        label: '数量',
      },
      {
        prop: 'TaxUnitPrice',
        label: '含税单价',
      },
      {
        prop: 'Sum',
        label: '价税合计',
      },
      ],
      state: [{
        title: '明细'
      },
      {
        title: '唯一码'
      }
      ],
      onchage: 0,
      tableflag: true,
      tableflags: false,
    }
  },
  mounted() { },
  methods: {
    // 明细
    async TransVouchDetail() {
      let {
        data,
        code
      } = await TransVouchDetail({
        tvmid: this.tvmid
      })
      if (code == 0) {
        this.tableDataDetail = data
      } else if (code == 101) {
        this.$message({
          type: 'warning',
          message: message
        });
      } else {
        this.$message({
          type: 'error',
          message: message
        });
      }
    },
    // 唯一码
    async TransVouchDetailUnique() {
      let {
        data,
        code,
        message
      } = await TransVouchDetailUnique({
        tvmid: this.tvmid
      })
      if (code == 0) {
        this.tableDataUnique = data
      } else if (code == 101) {
        this.$message({
          type: 'warning',
          message: message
        });
      } else {
        this.$message({
          type: 'error',
          message: message
        });
      }
    },
    clicktab(index) {
      if (index == 0) {
        this.tableflag = true
        this.tableflags = false
        this.TransVouchDetail()
      }
      if (index == 1) {
        this.tableflag = false
        this.tableflags = true
        this.TransVouchDetailUnique()
      }

      if (this.onchage != index) {
        this.onchage = index
      }
    }
  }
}
</script>

<style lang="less" scoped>
.ativte {
  border: 1px solid red;
  color: #e71d43;
  background-color: #fce8ec;
  transition: 0.2s linear;
}

.incenters {
  height: 100%;
  font-family: "微软雅黑";

  div {
    margin-left: 8px;
    margin-right: 8px;
    margin-top: 5px;
    margin-bottom: 5px;
    // width: 100%;
  }
}

.topstate {
  width: 100px;
  height: 32px;
  font-size: 14px;
  border: 1px solid #e6e6e6;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  display: inline-block;
  user-select: none;
}
</style>
